/**
 * Privacy consent manager – CCPA/CPRA best-effort, GPC support.
 * Manages consent state, injects marketing/analytics scripts only when allowed.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'privacy_choices';
  var COOKIE_DAYS = 365;
  var STORAGE_KEY = 'privacy_choices';

  function getConsentState() {
    try {
      var raw = document.cookie.split(';').map(function (s) { return s.trim(); }).filter(function (s) { return s.indexOf(COOKIE_NAME + '=') === 0; })[0];
      if (raw) {
        var json = decodeURIComponent(raw.split('=').slice(1).join('='));
        var state = JSON.parse(json);
        if (state && typeof state.necessary !== 'undefined') return state;
      }
      if (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) {
        return JSON.parse(localStorage.getItem(STORAGE_KEY));
      }
    } catch (e) {}
    return { necessary: true, analytics: false, marketing: false, gpc: false, bannerDismissed: false, updated: null };
  }

  function setConsentState(state) {
    state.updated = new Date().toISOString();
    try {
      var expires = new Date();
      expires.setDate(expires.getDate() + COOKIE_DAYS);
      document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(state)) + ';path=/;SameSite=Lax;expires=' + expires.toUTCString() + ';max-age=' + (COOKIE_DAYS * 86400);
      if (typeof localStorage !== 'undefined') localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
      if (typeof window.dispatchEvent !== 'undefined') {
        window.dispatchEvent(new CustomEvent('privacy-consent-updated', { detail: state }));
      }
    } catch (e) {}
  }

  function applyGPC() {
    if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true) {
      var state = getConsentState();
      state.gpc = true;
      state.marketing = false;
      state.analytics = false;
      setConsentState(state);
      return true;
    }
    return false;
  }

  function loadScript(src, id) {
    if (id && document.getElementById(id)) return;
    var script = document.createElement('script');
    script.async = true;
    if (id) script.id = id;
    script.src = src;
    document.head.appendChild(script);
  }

  function loadGTM(gtmId) {
    if (!gtmId) return;
    window.dataLayer = window.dataLayer || [];
    if (window.dataLayer.length === 0) {
      window.dataLayer.push({ customerLoggedIn: 0, customerId: 0, customerGroupId: 1, customerGroupCode: 'GENERAL', pageType: 'cms/index/index' });
      window.dataLayer.push({ ecommerce: { currencyCode: 'USD', currency: 'USD' } });
    }
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    loadScript('https://www.googletagmanager.com/gtm.js?id=' + String(gtmId).trim(), 'gtm-script');
  }

  function loadGorgias(url) {
    if (!url) return;
    var id = 'gorgias-chat-widget-install-v3';
    if (document.getElementById(id)) return;
    var script = document.createElement('script');
    script.id = id;
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  }

  function runConsentFlow() {
    var config = window.PrivacyConfig || {};
    var gpcActive = applyGPC();
    var state = getConsentState();

    if (config.enableTracking) {
      if (state.marketing && !gpcActive) {
        if (config.gtmId) loadGTM(config.gtmId);
        if (config.gorgiasUrl) loadGorgias(config.gorgiasUrl);
      }
      if (state.analytics && !gpcActive && config.gtmId) {
        loadGTM(config.gtmId);
      }
    }

    window.__privacyConsent = {
      getState: getConsentState,
      setState: setConsentState,
      applyGPC: applyGPC,
      loadGTM: loadGTM,
      loadGorgias: loadGorgias,
      gpcActive: gpcActive,
      showBanner: function () {
        var b = document.getElementById('privacy-consent-banner');
        if (b) b.classList.add('privacy-consent-banner--visible');
      },
      hideBanner: function () {
        var b = document.getElementById('privacy-consent-banner');
        if (b) b.classList.remove('privacy-consent-banner--visible');
        var s = getConsentState();
        s.bannerDismissed = true;
        setConsentState(s);
      },
      openModal: function () {
        var m = document.getElementById('privacy-consent-modal');
        if (m) {
          var state = getConsentState();
          var gpcOn = state.gpc || (typeof navigator !== 'undefined' && navigator.globalPrivacyControl === true);
          var analyticsEl = m.querySelector('[name="privacy-analytics"]');
          var marketingEl = m.querySelector('[name="privacy-marketing"]');
          if (analyticsEl) analyticsEl.checked = state.analytics;
          if (marketingEl) marketingEl.checked = state.marketing;
          if (gpcOn) {
            if (analyticsEl) analyticsEl.disabled = true;
            if (marketingEl) marketingEl.disabled = true;
            var notice = m.querySelector('.privacy-consent-gpc-notice');
            if (notice) notice.style.display = '';
          } else {
            if (analyticsEl) analyticsEl.disabled = false;
            if (marketingEl) marketingEl.disabled = false;
            var notice = m.querySelector('.privacy-consent-gpc-notice');
            if (notice) notice.style.display = 'none';
          }
          m.classList.add('privacy-consent-modal--open');
        }
      },
      closeModal: function () {
        var m = document.getElementById('privacy-consent-modal');
        if (m) m.classList.remove('privacy-consent-modal--open');
      },
      acceptNecessaryOnly: function () {
        var s = getConsentState();
        s.analytics = false;
        s.marketing = false;
        s.bannerDismissed = true;
        setConsentState(s);
        window.__privacyConsent.hideBanner();
        window.__privacyConsent.closeModal();
      },
      acceptAll: function () {
        var s = getConsentState();
        s.analytics = true;
        s.marketing = true;
        s.bannerDismissed = true;
        setConsentState(s);
        if (config.gtmId) loadGTM(config.gtmId);
        if (config.gorgiasUrl) loadGorgias(config.gorgiasUrl);
        window.__privacyConsent.hideBanner();
        window.__privacyConsent.closeModal();
      },
      saveModalPreferences: function () {
        var form = document.getElementById('privacy-consent-form');
        if (!form) return;
        var s = getConsentState();
        var analyticsEl = form.querySelector('[name="privacy-analytics"]');
        var marketingEl = form.querySelector('[name="privacy-marketing"]');
        s.analytics = !!(analyticsEl && analyticsEl.checked);
        s.marketing = !!(marketingEl && marketingEl.checked);
        setConsentState(s);
        if (s.marketing && config.gtmId) loadGTM(config.gtmId);
        if (s.marketing && config.gorgiasUrl) loadGorgias(config.gorgiasUrl);
        window.__privacyConsent.closeModal();
      }
    };

    if (!state.bannerDismissed) {
      var banner = document.getElementById('privacy-consent-banner');
      if (banner) banner.classList.add('privacy-consent-banner--visible');
    }

    var link = document.querySelector('[data-privacy-choices-link]');
    if (link) link.addEventListener('click', function (e) { e.preventDefault(); window.__privacyConsent.openModal(); });

    var acceptNecessary = document.querySelector('[data-privacy-accept-necessary]');
    if (acceptNecessary) acceptNecessary.addEventListener('click', function () { window.__privacyConsent.acceptNecessaryOnly(); });
    var customize = document.querySelector('[data-privacy-customize]');
    if (customize) customize.addEventListener('click', function () { window.__privacyConsent.openModal(); });
    var acceptAll = document.querySelector('[data-privacy-accept-all]');
    if (acceptAll) acceptAll.addEventListener('click', function () { window.__privacyConsent.acceptAll(); });
    var modalClose = document.querySelector('[data-privacy-modal-close]');
    if (modalClose) modalClose.addEventListener('click', function () { window.__privacyConsent.closeModal(); });
    var modalSave = document.querySelector('[data-privacy-modal-save]');
    if (modalSave) modalSave.addEventListener('click', function () { window.__privacyConsent.saveModalPreferences(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runConsentFlow);
  } else {
    runConsentFlow();
  }
})();
